import theme from "@/styles/theme";
import { DialogActions, type DialogActionsProps } from "@mui/material";

export function Footer({ children, sx, ...rest }: DialogActionsProps) {
	return (
		<DialogActions
			sx={{
				paddingTop: 2,
				paddingBottom: 2.5,
				paddingInline: 0,
				marginInline: 3,
				borderTopWidth: "1px",
				borderTopStyle: "solid",
				borderTopColor: theme.palette.divider,
				justifyContent: "space-between",
				gap: 1,
				...sx,
			}}
			{...rest}
		>
			{children}
		</DialogActions>
	);
}
